export const userInputs = [
  {
    id: 1,
    label: "Username",
    type: "text",
    placeholder: "john_doe",
  },
  {
    id: 2,
    label: "Name and surname",
    type: "text",
    placeholder: "John Doe",
  },
  {
    id: 3,
    label: "Email",
    type: "mail",
    placeholder: "john_doe@gmail.com",
  },
  {
    id: 4,
    label: "Phone",
    type: "text",
    placeholder: "+1 234 567 89",
  },
  {
    id: 5,
    label: "Password",
    type: "password",
  },
  {
    id: 6,
    label: "Address",
    type: "text",
    placeholder: "Elton St. 216 NewYork",
  },
  {
    id: 7,
    label: "Country",
    type: "text",
    placeholder: "USA",
  },
];

export const productInputs = [
  {
    id: 1,
    label: "Airlines",
    type: "text",
    placeholder: "IndiGo",
    className: ""
  },
  {
    id: 2,
    label: "Maximum Seats",
    type: "Number",
    placeholder: "60",
  },
  {
    id: 3,
    label: "Category",
    type: "text",
    placeholder: "Economy",
  },
  {
    id: 4,
    label: "Price",
    type: "text",
    placeholder: "100",
  },
  {
    id: 5,
    label: "No. of Stops",
    type: "Number",
    placeholder: "0",
  },
  {
    id: 6,
    label: "From",
    type: "date",
    placeholder: "in stock",
  },
  {
    id: 7,
    label: "To",
    type: "date",
    placeholder: "in stock",
  },
];
